import React from 'react';
import { PageSection } from '@gik/ui';
import { FeatureStepsGrid } from '.';
import bemBlock from '@gik/core/utils/bemBlock';

export const FeatureStepsSectionBlockName = 'feature-steps-section';

export default function FeatureStepsSection(): React.ReactElement {
  const bem = bemBlock(FeatureStepsSectionBlockName);

  return (
    <PageSection className={bem(null, null, 'gik-article')}>
      <FeatureStepsGrid />
    </PageSection>
  );
}
